import { render, staticRenderFns } from "./ProgressStripedBackground.vue?vue&type=template&id=1b13bfc2"
import script from "./ProgressStripedBackground.vue?vue&type=script&lang=js"
export * from "./ProgressStripedBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports